import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { C } from "../constants/colors";

/* @param confirmPhrase  optional. When set, she has to TYPE it before the
 *   confirm button will work — the guard for something that cannot be undone
 *   and cannot be re-derived. A dialog you can dismiss with a reflex is no
 *   guard at all on an irreversible thing, and "erase everything" here means
 *   her locked Accelerator work, not a chat log.
 *   Used sparingly, and it stops meaning anything the moment it is on
 *   something recoverable. */
export function ConfirmDialog({ title, message, confirmLabel, onConfirm, onCancel, danger, confirmPhrase }) {
  const [typed, setTyped] = useState("");
  const armed = !confirmPhrase || typed.trim() === confirmPhrase;
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 100,
      background: "rgba(0,0,0,0.6)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20,
    }}>
      <div style={{
        background: "#fff", borderRadius: 14, padding: "24px 22px",
        maxWidth: 380, width: "100%",
        boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
          <AlertTriangle size={18} color={danger ? C.salmon : C.teal} />
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: C.indigo }}>{title}</h3>
        </div>
        <p style={{ margin: confirmPhrase ? "0 0 14px" : "0 0 20px", fontSize: 13, color: "#555", lineHeight: 1.6 }}>{message}</p>

        {confirmPhrase && (
          <div style={{ marginBottom: 20 }}>
            <label htmlFor="confirm-phrase" style={{ display: "block", fontSize: 12.5, color: "#555", marginBottom: 6 }}>
              Type <b style={{ color: C.indigo, letterSpacing: "0.02em" }}>{confirmPhrase}</b> to confirm
            </label>
            <input id="confirm-phrase" value={typed} onChange={(e) => setTyped(e.target.value)} autoFocus
              autoComplete="off" spellCheck="false" placeholder={confirmPhrase}
              style={{
                width: "100%", boxSizing: "border-box", padding: "9px 11px", fontSize: 13,
                border: `1.5px solid ${armed ? C.salmon : "#e0dfe8"}`, borderRadius: 8, fontFamily: "inherit",
              }} />
          </div>
        )}
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onCancel} style={{
            padding: "8px 16px", borderRadius: 8, border: "1.5px solid #e0dfe8",
            background: "#fff", cursor: "pointer", fontSize: 13, color: "#666", fontWeight: 500,
          }}>
            Cancel
          </button>
          <button onClick={armed ? onConfirm : undefined} disabled={!armed} style={{
            padding: "8px 16px", borderRadius: 8, border: "none",
            background: danger ? C.salmon : C.teal,
            /* Visibly not-yet-pressable rather than pressable-and-ignored. */
            opacity: armed ? 1 : 0.4,
            cursor: armed ? "pointer" : "not-allowed", fontSize: 13, color: "#fff", fontWeight: 600,
          }}>
            {confirmLabel || "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
}
